// extracted by mini-css-extract-plugin
export var disabled = "_15-a";
export var hierarchyLinkGray = "_15-4";
export var hierarchyLinkUnderline = "_15-3";
export var hierarchyPrimary = "_15-0";
export var hierarchySecondary = "_15-1";
export var hierarchyTertiary = "_15-2";
export var pressed = "_15-6";
export var themeAction = "_15-5";
export var themeDestructive = "_15-8";
export var themeNormal = "_15-7";
export var themeSuccess = "_15-9";